import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { currenciesSchema } from "./schema";
import { fetchCurrenciesData } from "./read";
import { useUpdateCurrency } from "../update/mutation";
import { useCreateCurrency } from "../create/mutation";

export const useCurrencyForm = ({ currencyId }) => {
  const form = useForm({
    resolver: zodResolver(currenciesSchema),
    defaultValues: {
      name: "",
      budget_rate_inr: "",
      budget_rate_usd: "",
    },
  });

  const updateCurrency = useUpdateCurrency();
  const createCurrency = useCreateCurrency();

  const handleCreate = async (context) => {
    const item = context.values;
    await createCurrency.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateCurrency.mutateAsync({ currencyId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchCurrenciesData({ currencyId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
